import React, { useCallback } from 'react';
import { Bottom, BottomBox, BottomText, Description, Line, Link, LinkText, ModalBox, Title, TitleDiv } from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import Button from '../../button';
import copy from 'clipboard-copy';
import { captureException } from '../../../services/logService';
import Tooltip from '../../tooltip';
import { dispatchSettingSuccess } from '../../../services/settingServices';
import { BUTTON_TYPE, ICON_BUTTON_SIZE, ICON_BUTTON_TYPE } from '../../../global/constants';
import IconButton from '../../button/iconButton';
interface Props {
  onCancel?: () => void;
  clientLoginUrl: string;
  isFromTeam?: boolean;
}
export default function SuccessFullModal(props: Props) {
  const { isFromTeam } = props;

  const onClickCopy = useCallback(async (clientInviteUrl: string) => {
    try {
      if (clientInviteUrl !== undefined) {
        await copy(clientInviteUrl);
        dispatchSettingSuccess('Client invite url copied successfully!');
      }
    } catch (error) {
      captureException(error);
    }
  }, []);

  return (
    <ModalBox>
      <IconButton
        iconName='new-close-icon'
        size={ICON_BUTTON_SIZE.SMALL}
        variant={ICON_BUTTON_TYPE.TERTIARY}
        className='closeIcon'
        onClick={props?.onCancel}
      />
      <SVGIcon
        name={'subscripton-successful-icon'}
        width='56'
        height='56'
        viewBox='0 0 56 56'
        fill='var(--neutral-secondary)'
      />
      <BottomBox>
        <TitleDiv>
          <Title>Invitation Sent Successfully!</Title>
          <Description>
            Your {isFromTeam ? 'team' : 'client'} will receive an email with a link to join Teamcamp.
          </Description>
        </TitleDiv>
        <Line></Line>
        <Bottom>
          <BottomText>You can also share this link with them to join Teamcamp</BottomText>
          <Link>
            <Tooltip placement='bottom' maxWidth={'250px'} title={props.clientLoginUrl} isInModal={true}>
              <LinkText>{props.clientLoginUrl}</LinkText>
            </Tooltip>
            <Button
              title='Copy link'
              variant={BUTTON_TYPE.SECONDARY}
              className='button'
              size='small'
              onClick={() => onClickCopy(props.clientLoginUrl)}
            />
          </Link>
        </Bottom>
      </BottomBox>
    </ModalBox>
  );
}
